{
    "title": "dp item schema",
    "version": 0,
    "primaryKey": "_id",
    "type": "object",
    "properties": {
        "_id": {
            "type": "string",
            "maxLength": 100
        },
        "pk": {
            "type": "string"
        },
        "sk": {
            "type": "string"
        },
        "type": {
            "type": "string",
            "maxLength": 100
        },
        "relation": {
            "type": "string",
            "maxLength": 100
        },
        "synced": {
            "type": "boolean"
        },
        "version": {
            "type": "number"
        },
        "projectId": {
            "type": "string",
            "maxLength": 100
        },
        "serviceGroupId": {
            "type": "string",
            "maxLength": 100
        }
    },
    "required": ["_id", "pk", "type", "version", "synced"],
    "indexes": ["type", "relation", ["relation", "type"], "synced", ["projectId", "serviceGroupId"]]
}
